<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Methods
const numberFormat = (value) => {
    return new Intl.NumberFormat().format(value)
}

// Computed Properties
const listingName = computed(() => viewStore.listingName)
const pageSize = computed(() => viewStore.pageSize || 0)
const rawItemCount = computed(() => viewStore.itemCount || 0)

const itemCount = computed(() => {
    return numberFormat(rawItemCount.value)
})

const page = computed(() => viewStore.page || 1)

const from = computed(() => {
    return (page.value - 1) * pageSize.value + 1
})

const to = computed(() => {
    let calculatedTo = from.value + pageSize.value - 1
    return (calculatedTo > rawItemCount.value) ? rawItemCount.value : calculatedTo
})

const show = computed(() => {
    return (
        rawItemCount.value > 0 &&
        from.value !== false &&
        to.value !== false
    )
})
</script>

<template>
    <small v-show="show">
        <span class="from">{{ from }}</span>
        - <span class="to">{{ numberFormat(to) }}</span>
        of <span class="total">{{ itemCount }}</span>
    </small>
</template>